export function createShelfOrchestrator(context = {}) {
  const {
    state,
    loadCategoriesFromStorage,
    saveCategoriesToStorage,
    loadCollectionsFromStorage,
    saveCollectionsToStorage,
    loadBooklistsFromStorage,
    saveBooklistsToStorage,
    loadGlobalShelfOrderFromStorage,
    saveGlobalShelfOrderToStorage,
    updateGlobalShelfOrderForCollectionOrderInStorage,
    generateCollectionIdValue,
    generateBooklistIdValue,
    removeBooksFromAllCollectionsFromModule,
    removeBooksFromAllBooklistsFromModule,
    addBooksToCollectionFromModule
  } = context;

  function loadCategories() {
    loadCategoriesFromStorage(state);
  }

  function saveCategories() {
    saveCategoriesToStorage(state);
  }

  function loadCollections() {
    loadCollectionsFromStorage(state);
  }

  function saveCollections() {
    saveCollectionsToStorage(state);
  }

  function loadBooklists() {
    loadBooklistsFromStorage(state);
  }

  function saveBooklists() {
    saveBooklistsToStorage(state);
  }

  function loadGlobalShelfOrder() {
    loadGlobalShelfOrderFromStorage(state);
  }

  function saveGlobalShelfOrder() {
    saveGlobalShelfOrderToStorage(state);
  }

  function updateGlobalShelfOrderForCollectionOrder(orderedCollectionIds) {
    updateGlobalShelfOrderForCollectionOrderInStorage(state, orderedCollectionIds);
  }

  function generateCollectionId() {
    return generateCollectionIdValue();
  }

  function generateBooklistId() {
    return generateBooklistIdValue();
  }

  function removeBooksFromAllCollections(bookIds) {
    return removeBooksFromAllCollectionsFromModule(state, bookIds, saveCollections);
  }

  function removeBooksFromAllBooklists(bookIds) {
    return removeBooksFromAllBooklistsFromModule(state, bookIds, saveBooklists);
  }

  function addBooksToCollection(collectionId, bookIds) {
    addBooksToCollectionFromModule(state, collectionId, bookIds, saveCollections);
  }

  return {
    loadCategories,
    saveCategories,
    loadCollections,
    saveCollections,
    loadBooklists,
    saveBooklists,
    loadGlobalShelfOrder,
    saveGlobalShelfOrder,
    updateGlobalShelfOrderForCollectionOrder,
    generateCollectionId,
    generateBooklistId,
    removeBooksFromAllCollections,
    removeBooksFromAllBooklists,
    addBooksToCollection
  };
}
